import { TTaskSelect } from "@/models/company_teammates";

export const ADMIN_VALUE = "admin";
export const MEMBER_VALUE = "member";

export const ADMIN_LABEL = "Admin";
export const MEMBER_LABEL = "Member";

export const PERMISSION_TYPES: TTaskSelect[] = [
  { value: ADMIN_VALUE, label: ADMIN_LABEL },
  { value: MEMBER_VALUE, label: MEMBER_LABEL },
];
